import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import { Partner } from '../../models/stack9/Partner';
import { EntityDrawer } from '../EntityDrawer/EntityDrawer';

type PartnerDrawerProps = {
  open: boolean;
  onClose: () => void;
  id?: number;
  initialValues?: Partial<Partner>;
};

export const PartnerDrawer = ({
  open,
  onClose,
  id,
  initialValues,
}: PartnerDrawerProps) => {
  const formFields = [
    { field: 'registered_number' },
    { field: 'registered_name' },
    { field: 'trade_as_name' },
    { field: 'address_line_1' },
    { field: 'address_line_2' },
    { field: 'suburb', colSize: 6 },
    { field: 'post_code', colSize: 6 },
    { field: 'state', colSize: 6 },
    { field: 'country', colSize: 6 },
    { field: 'is_active' },
  ];

  return (
    <EntityDrawer
      title="partner"
      open={open}
      id={id}
      formFields={formFields}
      initialValues={initialValues}
      onClose={onClose}
      screenQueryName={EDetailsQueryNames.GetPartnerDetails}
      entityName={entityNames.PARTNER}
      editRoute={AppRoutes.PartnerDetail}
      relativePath={AppRoutes.PartnerList}
    />
  );
};
